import React from 'react';
import { Alert, Button, Space } from 'antd';
import { DownloadOutlined, CloseOutlined } from '@ant-design/icons';
import usePwaInstall from '../hooks/usePwaInstall';

export default function PwaInstallBanner() {
  const { visible, isIos, hasNativePrompt, install, dismiss } = usePwaInstall();

  if (!visible) return null;

  const message = isIos
    ? 'Установите приложение на iPhone'
    : 'Установите приложение ЛОГИСТ';

  const description = isIos ? (
    <span>
      Нажмите <strong>Поделиться</strong> внизу Safari → <strong>На экран «Домой»</strong>.
      Так уведомления и офлайн-режим работают стабильнее.
    </span>
  ) : hasNativePrompt ? (
    <span>
      Добавьте ярлык на рабочий стол — удобнее для работы в дороге, push и офлайн.
    </span>
  ) : (
    <span>
      Откройте меню браузера (⋮) → <strong>Установить приложение</strong> или{' '}
      <strong>Добавить на главный экран</strong>.
    </span>
  );

  return (
    <Alert
      type="warning"
      showIcon
      message={message}
      description={description}
      style={{ margin: '8px 0 12px', borderRadius: 8 }}
      action={
        <Space direction="vertical" size={4}>
          {!isIos && hasNativePrompt && (
            <Button
              type="primary"
              size="small"
              icon={<DownloadOutlined />}
              onClick={install}
            >
              Установить
            </Button>
          )}
          <Button
            type="text"
            size="small"
            icon={<CloseOutlined />}
            onClick={dismiss}
          >
            Не сейчас
          </Button>
        </Space>
      }
    />
  );
}
